<template>
    <div>
        <button v-if="isBtn" class="btn_structure" :class="value" type="button" @click="clickFunction">
            {{ view }}
        </button>
        <a v-else-if="!isBtn" class="btn_structure" :href="anchor" target="_self" :class="value">
            {{ view }}
        </a>
    </div>
</template>
<script>
export default {
    name: "btn-delete",
    props: ["view", "propFunction", "value", "isBtn", "anchor"],
    data() {
        return {};
    },

    mounted() {
    },

    methods: {
        clickFunction() {
            this.propFunction()
        }
    },

}
</script>
<style lang="scss" scoped>
.btn_structure {
    width: auto;
    min-width: 10rem;
    max-width: 14.5rem;

    height: auto;
    min-height: 3.2rem;
    max-height: 3.8rem;

    padding: .2rem .4rem;

    border-radius: 6px;
    border: 0;

    color: #FFFFFF;

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: 'Muli';
    font-size: 1.2rem;
    font-weight: 600;

    &.red {
        background-color: #EF4411;
    }
    &.blue {
        background-color: #0080FC;
    }
    &.grey {
        background-color: #C4C4C4;
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/delete-account/components/btn-delete.vue